<script setup lang="ts">
import type { NovaMentionProps } from './NovaMention.types'

defineProps<NovaMentionProps>()
</script>

<template>
  <span class="mention">@{{ userName }}</span>
</template>

<style lang="scss" scoped>
.mention {
  display: inline;
  padding: 3px 10px;
  @include text-style($text-body-14-regular);
  line-height: 18px;
  color: $color-text-2;
  border-radius: $radius-10;
  background-color: $color-secondary-blue-light-10;
}
</style>
